import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import FormSpinner from '../../common/utility/FormSpinner';
import LastOrder from './LastOrder';
import Upcoming from './Upcoming';
import FileActionsTable from './FileActionsTable';
import './account-home-page.scss';
import FormMessage from '../../common/utility/FormMessage';
import { isEmpty } from '../../utils/obj-utils';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formConstants } from '../../utils/constants/form-constants';
import { getMultilineText } from '../../../../../general/js/utils';
import withLoadingInterval from '../../hocComponents';

class AccountHomePage extends Component {
    constructor(props) {
        super(props);

        this.loadHomePageTicketsData = this.loadHomePageTicketsData.bind(this);
        this.loadHomePageTicketsData();
        this.errorMessages = this.props.loadHomePageTicketsDataErrorMessages;
    }

    componentWillUnmount() {
        const { actions } = this.props;

        actions.resetHomePageTicketsData();
    }

    loadHomePageTicketsData() {
        const { actions, formData } = this.props;

        actions.getHomePageTicketsData(
            formData.getHomePageTicketsDataCallbackUrl,
            formData[formConstants.ssoDomain],
            formData[formConstants.secuTixErrorMessage]
        );
    }

    checkElapsedTimeMessage() {
        const { formData, elapsedTime } = this.props;
        const loadingErrorMessage = formData[formConstants.loadingErrorMessage];

        if (!loadingErrorMessage) {
            this.errorMessages = this.props.loadHomePageTicketsDataErrorMessages;
            return;
        }
        const elapsedTimeLimit = formData[formConstants.elapsedTimeLimit];

        if (elapsedTime > elapsedTimeLimit && !this.errorMessages.includes(loadingErrorMessage)) {
            this.errorMessages.push(loadingErrorMessage);
        } else {
            this.errorMessages = this.props.loadHomePageTicketsDataErrorMessages;
        }
    }

    render() {
        const {
            loading,
            formData,
            isTicketsDataLoadedSuccessful,
            homePageTicketsData,
            onViewFileSummaryClick,
            onViewTicketsClick,
            elapsedTime
        } = this.props;
        const { actionItems, upcomingTicket, lastOrder } = homePageTicketsData;
        const actionsToPerformValue = isEmpty(actionItems) ? formMessageConstants.emptyString : actionItems.length;
        const {
            formTitle,
            formSubTitle,
            orderType,
            actionOrderType,
            fileState,
            noOrdersFoundText,
            noActionsToPerformText,
            noUpcomingEventText,
            showExpiryDate,
            showParkingButton,
            showParkingButtonText,
            parkingButtonUrl,
            ssoDomain,
        } = formData;

        const formSubtitleSplit = getMultilineText(formSubTitle);
        const shouldDisplayHomePageTicketsData = !loading &&
        isTicketsDataLoadedSuccessful && !isEmpty(homePageTicketsData);

        this.checkElapsedTimeMessage();
        const elapsedTimeLimit = formData[formConstants.elapsedTimeLimit];
        const loadingErrorMessage = formData[formConstants.loadingErrorMessage];
        const elapsedTimeError = elapsedTime >= elapsedTimeLimit && !!loadingErrorMessage;

        return (
            <Fragment>
                {loading ? <FormSpinner >/</FormSpinner> : null}
                <h1>{formTitle}</h1>
                {formSubtitleSplit.map((subtitle) => {
                    return <div key={_.uniqueId()} className='dashboard-info'>{subtitle}</div>;
                })}
                <div className='category my-account-dashboard'>
                    <FormMessage
                        isSuccessMessage={isTicketsDataLoadedSuccessful && !elapsedTimeError}
                        messages={this.errorMessages}>
                    </FormMessage>
                    {shouldDisplayHomePageTicketsData &&
                        <h2>{formMessageConstants.actionsToPerform}
                            {isEmpty(actionItems) || <span className='actions-number'>{actionsToPerformValue}</span>}
                        </h2>}
                    {shouldDisplayHomePageTicketsData &&
                        <FileActionsTable
                            files={actionItems}
                            noActionsToPerformText={noActionsToPerformText}
                            orderTypeValues={actionOrderType}
                            onViewFileSummaryClick={onViewFileSummaryClick}
                            showExpiryDate = {showExpiryDate}></FileActionsTable>}
                    {shouldDisplayHomePageTicketsData &&
                        <Upcoming
                            upcomingTicket={upcomingTicket}
                            noUpcomingEventText={noUpcomingEventText}
                            ssoDomain={ssoDomain}
                            showParkingButton = {showParkingButton}
                            showParkingButtonText = {showParkingButtonText}
                            parkingButtonUrl = {parkingButtonUrl}
                            onViewTicketsClick={onViewTicketsClick}></Upcoming>}
                </div>
                {shouldDisplayHomePageTicketsData &&
                    <LastOrder
                        lastOrder={lastOrder}
                        noOrdersFoundText={noOrdersFoundText}
                        orderTypeValues={orderType}
                        fileStateValues={fileState}
                        onViewLastOrderSummaryClick={onViewFileSummaryClick}></LastOrder>}
            </Fragment >
        );
    }
}

AccountHomePage.propTypes = {
    loading: PropTypes.bool.isRequired,
    formData: PropTypes.object.isRequired,
    onViewFileSummaryClick: PropTypes.func.isRequired,
    onViewTicketsClick: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        homePageTicketsData: state.userAccount.homePageTicketsData,
        loadHomePageTicketsDataErrorMessages: state.userAccount.loadHomePageTicketsDataErrorMessages,
        isTicketsDataLoadedSuccessful: state.userAccount.isTicketsDataLoadedSuccessful,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            getHomePageTicketsData: bindActionCreators(userAccountActions.getHomePageTicketsData, dispatch),
            resetHomePageTicketsData: bindActionCreators(userAccountActions.resetHomePageTicketsData, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withLoadingInterval(AccountHomePage));
